import React from "react";
import Navbar from "../LandingPage/Navbar/Navbar";
import Footer2 from "../Footer2/Footer2";
import TopBar from "../EdofSectionNew2/TopBar/TopBar";
const NotFound = () => {
  return (
    <>
    <TopBar/>
      <Navbar />
      <div
        style={{
          textAlign: "center",
          marginTop: "100px",
        
          fontSize: "22px",
        }}
      >
        <h2 className="notfound" style={{fontSize: "50px",}}><span className="diffentFamily">4</span>0<span className="diffentFamily">4</span></h2>
        <p className="notfound1">Page Not Found</p>
      </div>
      <Footer2 />
    </>
  );
};

export default NotFound;
